module.exports = __webpack_public_path__ + "static/media/logo.2ef3b351.svg";